<template>
  <div id="publishing-journal-website-sections-import">
    <ipub-model title="Import Sections"
                width="800px"
                height="646px"
                :showFooter="false"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <div class="ipub-p2 mar-b-20 font-color"
           style="width:455px">
        <div class="mar-b-10">The fomat has to be strictly followed the templated provided here.</div>
        <div class="mar-b-10">All the information in the Excel has to be filled up. Otherwise, it might cause the failure of uploading.</div>
        <div class="mar-b-10">One file can only support maxium 1000 line of data.</div>
      </div>
      <div class="mar-b-40 ipub-p1">
        <ipub-button plain
                     @click="download"
                     type="primary">Download Template</ipub-button>
      </div>
      <div class="ipub-p1 mar-b-10">Upload File</div>
      <template v-if="!progress.status">
        <ipub-upload class="mar-b-20"
                     style="width:100%"
                     @change="handleUpload">
          <div class="upload-content">
            <font class="font-color"
                  style="font-size:60px">
              <ipub-icon type="iconSubmitYourPaper" />
            </font>
            <div class="ipub-p1 mar-b-20 font-color">Drag your file here for uploading </div>
            <ipub-button class="ipub-p1"
                         type="primary">Upload File</ipub-button>
          </div>
        </ipub-upload>
        <div class="font-color ipub-p2">Choose the file you want to import. Only one file a time. </div>
      </template>
      <template v-else>
        <ipub-progress class="mar-b-10"
                       :progress="progress.progress"
                       :type="progress.status" />
        <div v-if="progress.status === 'PROCESSING'"
             class="ipub-p2 font-color">{{file.name}}</div>
        <template v-else>
          <a :href="`${domain}/${progress.msg}`"
             download
             v-if="progress.status === 'FAILURE'"
             class="ipub-p2 font-color link-color">{{`${domain}/${progress.msg}`}}</a>
          <div v-else-if="progress.status === 'STOP'"
               class="key-color">{{progress.msg}}</div>
          <div class="ipub-p1"
               style="margin-top: 30px">
            <ipub-button plain
                         @click="clear"
                         type="primary">Upload Again</ipub-button>
            <ipub-button @click="confirm"
                         type="primary">Back to Page</ipub-button>
          </div>
        </template>
      </template>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import section from '../../../../api/section'
import help from '../../../../utils/help'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    journalId: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
    })
  },
  watch: {
    async isVisable (val) {
      if (!val) {
        this.clear()
      }
    }
  },
  data () {
    return {
      params: '',
      progressId: '',
      file: '',
      progress: {}
    }
  },
  methods: {
    async handleUpload (files) {
      const file = files[0]
      const types = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
      const rightType = types.includes(file.type)
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }

      this.params = new FormData()
      this.params.append('journalId', this.journalId)
      this.params.append('file', file)
      this.file = file

      this.progressId = await section.import(this.params)

      const timer = setInterval(async () => {
        this.progress = await section.getProcess(this.progressId)
        if (this.progress.progress === 100) {
          clearInterval(timer)
        }
      }, 1000)
    },
    confirm () {
      this.$emit('confirm')
    },
    cancel () {
      this.$emit('cancel')
    },
    async download () {
      const res = await section.download()
      help.download(res.url, 'Import Sections Template.xlsx')
    },
    clear () {
      this.progress = {}
      this.progressId = ''
      this.params = ''
      this.file = ''
    }
  }
}
</script>

<style lang="scss" scoped>
#publishing-journal-website-sections-import {
  .upload-content {
    background: $body_color;
    border: 1px solid $border_color;
    border-radius: 4px;
    padding: 20px;
    text-align: center;
  }
}
</style>
